module.exports = __webpack_public_path__ + "static/media/suspension_blue.da327eed.png";